<template>
<Tooltip transfer :content="validMsg" theme="err" :disabled="!(validErr&&validErrMsgTip)"  class="ivu-table-cell-tooltip">
    <div  :class="getEditClass" @mouseenter="validErrMsgTipIn" @mouseleave="validErrMsgTipOut">
        <template>
            <div :class="[prefixCls + '-rel']">
                <template>
                    <Tooltip v-if="editCfg.dataCfg.value" transfer :content="myContent" :disabled="!showTooltip" class="ivu-table-cell-tooltip">
                        <p ref="myContent" @mouseenter="handleTooltipIn" @mouseleave="handleTooltipOut" class="ivu-table-cell-tooltip-content">{{ myContent }}</p>
                    </Tooltip>
                    <Tooltip v-else transfer :content="showContent" :disabled="!showTooltip" class="ivu-table-cell-tooltip">
                        <p ref="content" @mouseenter="handleTooltipIn" @mouseleave="handleTooltipOut" class="ivu-table-cell-tooltip-content">{{ showContent }}</p>
                    </Tooltip>
                </template>
            </div>
            <template>
              <div
                  :class="[prefixCls + '-popper']"
                  v-if="visible">
                  <div :class="[prefixCls + '-content']">
                      <dropdown 
                          v-if="editCfg.dataCfg.value"
                          @on-blur="onBlur"
                          @on-focus="onFocus"
                          @onChange="change" 
                          isFocused 
                          :filterable="editCfg.filterable&&editCfg.filterable"
                          v-model="selectData"
                          @on-query-change="onQueryChange" 
                          :disabled="disabled" 
                          :dataCfg="{value:editCfg.dataCfg.value}" 
                          :label="editCfg.label" 
                          :code="editCfg.key"></dropdown> 
                      <dropdown 
                          v-else
                          @on-blur="onBlur"
                          @on-focus="onFocus"
                          @onChange="change" 
                          isFocused 
                          @on-query-change="onQueryChange"
                          :filterable="editCfg.filterable&&editCfg.filterable"
                          v-model="selectData" 
                          :disabled="disabled" 
                          :dataCfg="{value:getDataList}" 
                          :label="editCfg.label" 
                          :code="editCfg.key"></dropdown> 
                  </div>
              </div>
            </template>
        </template>
    </div>
</Tooltip>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import Tooltip from "../../tooltip/tooltip.vue";
const prefixCls = "table-edit";
export default {
  name: "plugDropdown",
  components: { Tooltip },
  computed: {
    showContent() {
      if(!this.isInit)return ''
      let tContent=this.$store.getters["components/getDropDataById"](
          this.col,
          this.content
        )||this.content
      return tContent
    },
    getDataList() {
      return this.$store.getters["components/getDropDataList"](this.col);
    },
    getEditClass() {
      return [
        `${this.prefixCls}`,
        {
            [`${this.prefixCls}-always`]: (this.editAlways||this.always)&&!this.visible,
            [`${this.prefixCls}-disabled`]:this.getDisabled(),
            [`${this.prefixCls}-cell-valid-err`]: this.validErr === true&&!this.visible
        }
      ];
    }
  },
  props: {
    content: {
      type: [String, Number],
      default: ""
    },
    col: [String, Number, Object],
    row: [String, Number, Object],
    editCfg: Object,
    //初始化数据前
    onBeforeSetDataList: {
      type: Function
    },
    dropIndex: Number,
    dropInit: Boolean,
    disabled: {
      type: Boolean,
      default: false
    },
    visible: {
      type: Boolean,
      default: false
    },
    always: {
      type: Boolean,
      default: false
    },
    validErr:{
      type: Boolean,
      default: false
    },
    validMsg:String,
    editAlways:{
      type: Boolean,
      default: false
    },
    maxWidth: {
      type: [String, Number]
    }
  },
  data() {
    return {
      prefixCls: prefixCls,
      selectData: "",
      myContent:"",
      showTooltip: false,
      validErrMsgTip:false,
      isInit:false
    };
  },
  watch: {
      content(){
          this.setMyContent()
      }
  },
  methods: {
    onBlur() {
      this.$emit("onChangeShowEdit", false,this.selectData);
    },
    onFocus(){
    },
    change(value) {
      this.$emit("onChange", value, this.col);
    },
    handleTooltipIn() {
      const $content = this.editCfg.dataCfg.value?this.$refs.myContent:this.$refs.content;
      this.showTooltip = $content.scrollWidth > $content.offsetWidth;
    },
    handleTooltipOut() {
      this.showTooltip = false;
    },
    validErrMsgTipIn(){
      this.validErrMsgTip=true
    },
    validErrMsgTipOut(){
      this.validErrMsgTip=false
    },
    //当输入查询条件改变
    onQueryChange(data){
      this.$emit("on-query-change", data);
    },
    getContent(value, isFrist) {
      let dataList = this.editCfg.dataCfg.value,
        strs = "";
      for (let i = 0; i < dataList.length; i++) {
        let item = dataList[i];
        if (value == item[this.editCfg.key]) {
          strs = item[this.editCfg.label];
          if (isFrist) {
            this.selectData = value;
          }
          continue;
        }
      }
      return strs;
    },
    setMyContent(isFrist){
        if(this.editCfg.dataCfg.value){
            this.myContent=this.getContent(this.content,isFrist)
        }else{
            this.$store.dispatch("components/setDropCacheData", {col:this.col,row:this.row});
            this.selectData = this.content;
        }
    },
    getDisabled(item) {
       let myDisabled=this.editCfg.setDisabled
        ? this.editCfg.setDisabled(this.col, this.row, this.editCfg)
        : this.editCfg.disabled;
        if(myDisabled){
            this.$emit("setColEditDisabled", myDisabled);
        }
        return myDisabled
    },
  },
  mounted() {
    this.isInit=true
    this.setMyContent(true)
  }
};
</script>




// WEBPACK FOOTER //
// src/components/common/table/plug/dropdown.vue